import texgyreherosFont from './texgyreheros-regular-webfont';
import texgyreherosBoldFont from './texgyreheros-bold-webfont';

export default {
    'TeX-Gyre-Heros': {
        normal: {
            ttf: 'texgyreheros-regular-webfont.ttf',
            base64: texgyreherosFont
        },
        bold: {
            ttf: 'texgyreheros-bold-webfont.ttf',
            base64: texgyreherosBoldFont
        }
    }
};
